import React, { useState, useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Header from "./components/page/Header.tsx";
import LoadingPxchSmall from "../../components/LoadingPxch/LoadingPxchSmall/LoadingPxchSmall.tsx";
import SkeletonGridCard from "../myFavoritesMedia/LinksPage/SkeletonGridCard/SkeletonGridCard.tsx";
import TableCustomeHandle from "../../components/Tables/TableCustomeHandle/TableCustomeHandle.tsx";
import InviteCard from "./components/page/InviteCard.tsx";
import InviteShareModal from "./components/page/InviteShareModal.tsx";
import MeetingSelectionModal from "./components/page/MeetingSelectionModal.tsx";
import ConfirmationModal from "./components/page/ConfirmationModal.tsx";
import dayjs from "dayjs";
import { Invite } from "./types/Invites.tsx";
import { MeetingType } from "./types/Meeting.tsx";
import AddEmpty from "./components/page/AddEmpty.tsx";
import { useNavigate } from "react-router-dom";
import { objetoAParametrosFetch } from "../../components/Tables/helper/fetchParams.ts";
import { getOrgName } from "../../commons/functions/url.js";
import { invites_dataset } from "./dataset.ts";

export default function AiSocialPage() {
  const navigate = useNavigate();
  const { user, getAccessTokenSilently, isLoading } = useAuth0();
  const [token, setToken] = useState<any>(undefined);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [selectedInvite, setSelectedInvite] = useState<Invite | undefined>(
    undefined
  );
  const [isMeetingSelectionOpen, setIsMeetingSelectionOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState<
    MeetingType | undefined
  >(undefined);

  const tablaRef = useRef<any>(null);

  useEffect(() => {
    const getToken = async () => {
      let tokenTemp = await getAccessTokenSilently();
      setToken(tokenTemp);
    };
    getToken();
  }, []);

  /**
   * Function to fetch AI Social invites data
   */
  const getAllData = async ({
    page = 1,
    size,
    filters,
    textFilter,
    textFilterFieldName,
  }) => {
    try {
      // Mock data for now - replace with actual API call
      const mockInvites: Invite[] = invites_dataset;

      let queryParams = "";
      if (filters || textFilter) {
        queryParams =
          objetoAParametrosFetch(filters, textFilter, textFilterFieldName) ||
          "";
      }
      // const options = {
      //   method: "GET",
      //   headers: {
      //     authorization: "bearer " + token,
      //   },
      // };
      // const url = `${
      //   process.env.REACT_APP_PUBLIC_AI_INVITES
      // }/list-all?page_size=${size}&page_number=${page}&org_name=${getOrgName()}&${queryParams}`;
      // const resp = await fetch(url, options);
      // if (resp.status === 401) {
      //   return new Error("Forbidden");
      // }
      // if (resp.status === 500) {
      //   return new Error("Server Error fetching: ordenes diarias");
      // }
      // const data = await resp.json();
      let listaTemp = mockInvites; //data?.affiliate_links;
      return {
        //...data,
        data: listaTemp,
        total: listaTemp.length,
        page,
        totalPages: Math.ceil(listaTemp.length / size),
      };
    } catch (error) {
      console.error("Fail to fetch AI Social invites:", error);
      return undefined;
    }
  };

  const onShareInvite = (invite: Invite) => {
    setSelectedInvite(invite);
    setIsShareOpen(true);
  };

  const onCreate = () => {
    setIsMeetingSelectionOpen(true);
  };

  const onSelectMeeting = (meeting: MeetingType) => {
    setSelectedMeeting(meeting);
    setIsMeetingSelectionOpen(false);
    setIsConfirmationOpen(true);
  };

  const onConfirmGeneration = () => {
    if (selectedMeeting) {
      navigate(`/generate-ai-social?m=${selectedMeeting.meetingId}`);
    }
  };

  const onNewInvite = () => {
    navigate(`/generate-ai-social`);
  };

  const onCancelConfirmation = () => {
    setIsConfirmationOpen(false);
    setIsMeetingSelectionOpen(true);
  };

  if (isLoading || !token) {
    return <LoadingPxchSmall />;
  }

  return (
    <>
      <Header />
      <div className="md:min-w-[500px] pb-4 w-full relative flex-1 flex flex-col gap-y-2 overflow-y-auto">
        <TableCustomeHandle
          ref={tablaRef}
          isList
          multiplicador={5}
          containerClassName="grid grid-cols-1 gap-3 sm:gap-4 md:grid-cols-2 lg:grid-cols-3"
          Skeleton={<SkeletonGridCard />}
          dataFetch={getAllData}
          rowsPerPageOptions={[12, 24, 48]}
          searchName="ai-social-list"
          addEmptyComponent={() => {
            return <AddEmpty onClick={onCreate} />;
          }}
        >
          {(invite: Invite, index: number) => {
            return (
              <InviteCard
                key={invite._id}
                invite={invite}
                onShare={onShareInvite}
              />
            );
          }}
        </TableCustomeHandle>
      </div>

      {selectedInvite && isShareOpen && (
        <InviteShareModal
          isOpen={isShareOpen}
          onClose={() => setIsShareOpen(false)}
          invite={selectedInvite}
        />
      )}

      <MeetingSelectionModal
        isOpen={isMeetingSelectionOpen}
        onClose={() => setIsMeetingSelectionOpen(false)}
        onSelectMeeting={onSelectMeeting}
        onSelect={onNewInvite}
        token={token}
      />

      {selectedMeeting && (
        <ConfirmationModal
          isOpen={isConfirmationOpen}
          meeting={selectedMeeting}
          onConfirm={onConfirmGeneration}
          onCancel={onCancelConfirmation}
        />
      )}
    </>
  );
}
